import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageUtilService<T> {

  constructor(private localstorage: Storage) { }

  public getItem(key: string): T {
    return JSON.parse(this.localstorage.getItem(key) as string);
  }

  public setItem(key: string, value: T): void {
    this.localstorage.setItem(key, JSON.stringify(value));
  }

  public removeItem(key: string): void {
    this.localstorage.removeItem(key);
  }

  getItemWithExpiration(key: string): any {
    const itemStr = this.localstorage.getItem(key);
    if (!itemStr) return null;
  
    const item = JSON.parse(itemStr);
    const now = new Date().getTime();
  
    if (now > item.expiration) {
      this.localstorage.removeItem(key);
      return null;
    }
  
    return item.value;
  }

  setItemWithExpiration(key: string, value: any, days: number) {
    const now = new Date();
    const expirationDate = now.getTime() + days * 24 * 60 * 60 * 1000;
    const item = {
      value: value,
      expiration: expirationDate
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
}
